import { IconMap } from '../../shared/sprite';

export const FILTER_TEMPLATE_ITEMS = {
  allTypes: { glyph: IconMap.LayersThree01, label: 'All types' },
  onePage: { glyph: IconMap.OnePage, label: 'Single-tab' },
  multiPage: { glyph: IconMap.MultiTabPage, label: 'Multi-tab' },
} as const;
